import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {IconsProviderModule} from './icons-provider.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NZ_I18N} from 'ng-zorro-antd/i18n';
import {en_US} from 'ng-zorro-antd/i18n';
import {LocationStrategy, PathLocationStrategy, registerLocaleData} from '@angular/common';
import en from '@angular/common/locales/en';
import {environment} from '@env';
import {LayoutModule} from './layout/layout.module';
import {CoreModule} from '@app/core.module';
import {ErrorInterceptor} from '@app/interceptor/error.interceptor';
import {SharedModule} from '@shared/shared.module';
import {TokenInterceptor} from '@app/interceptor/token.interceptor';
import {AuthModule} from '@modules/auth/auth.module';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {NzLayoutModule} from 'ng-zorro-antd/layout';

import {TimingInterceptor} from '@app/interceptor/timing.interceptor';
import {provideFirebaseApp} from '@angular/fire/app';
import {connectDatabaseEmulator, getDatabase, provideDatabase} from '@angular/fire/database';
import {NgxsLoggerPluginModule} from '@ngxs/logger-plugin';
import {NgxsModule} from '@ngxs/store';
import {VehicleState} from '@shared/state/vehicle/vehicle.state';
import {NgxsReduxDevtoolsPluginModule} from '@ngxs/devtools-plugin';
import {NgxsRouterPluginModule} from '@ngxs/router-plugin';
import {getApp, initializeApp} from '@firebase/app';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {
  connectFirestoreEmulator,
  enableMultiTabIndexedDbPersistence,
  getFirestore,
  provideFirestore
} from '@angular/fire/firestore';
import {connectAuthEmulator, initializeAuth, provideAuth} from '@angular/fire/auth';
import {getPerformance, providePerformance} from '@angular/fire/performance';
import {getMessaging, provideMessaging} from '@angular/fire/messaging';

import {
  browserLocalPersistence,
  browserPopupRedirectResolver,
  indexedDBLocalPersistence
} from 'firebase/auth';
import { provideRemoteConfig,getRemoteConfig } from '@angular/fire/remote-config';
import { provideStorage,getStorage } from '@angular/fire/storage';

registerLocaleData(en);
initializeApp(environment.firebase);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    HttpClientModule,
    IconsProviderModule,

    provideFirebaseApp(() => getApp()),
    provideDatabase(() => {
      const database = getDatabase();
      if (environment.useEmulators) {
        connectDatabaseEmulator(database, 'localhost', 9001);
      }
      return database;
    }),
    provideAuth(() => {
      const auth = initializeAuth(getApp(), {
        persistence: [indexedDBLocalPersistence, browserLocalPersistence],
        popupRedirectResolver: browserPopupRedirectResolver
      });
      if (environment.useEmulators) {
        connectAuthEmulator(auth, 'http://localhost:9099', {disableWarnings: true});
      }
      return auth;
    }),
    provideFirestore(() => {
      const firestore = getFirestore();
      if (environment.useEmulators) {
        connectFirestoreEmulator(firestore, 'localhost', 8081);
      }
      enableMultiTabIndexedDbPersistence(firestore)
        .catch((err) => {
          console.log('enableIndexedDbPersistence', err);
        });
      return firestore;
    }),
    provideMessaging(() => getMessaging()),
    // providePerformance(() => getPerformance()),
    // provideRemoteConfig(() => getRemoteConfig()),
    // provideStorage(() => getStorage()),

    NgxsLoggerPluginModule.forRoot({
      disabled: environment.production
    }),
    NgxsModule.forRoot(
      [VehicleState],
      {developmentMode: !environment.production}
    ),
    NgxsReduxDevtoolsPluginModule.forRoot({
      disabled: environment.production
    }),
    NgxsRouterPluginModule.forRoot(),

    AppRoutingModule,

    CoreModule,
    AuthModule,
    LayoutModule,

    FontAwesomeModule,
    SharedModule,
    NzLayoutModule,
    FormsModule,
    BrowserAnimationsModule,
    NzMenuModule,
  ],
  providers: [
    {provide: NZ_I18N, useValue: en_US},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: TimingInterceptor, multi: true},
    {provide: LocationStrategy, useClass: PathLocationStrategy},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
